import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// GSAP parallax for .bg inside section.h-01-header
// Simple settings live here; caller only needs to invoke the function.
export function dm_h_01_header() {
	if (typeof window === 'undefined') return;

	var sections = gsap.utils.toArray('.h-01-header');
	if (!sections.length) return;

	sections.forEach(function (section) {
		var bg = section.querySelector('.bg');
		if (!bg) return;

		bg.style.willChange = 'transform';
		bg.style.transformOrigin = 'top center';

		gsap.to(bg, {
			yPercent: -15,
			scale: 1.35,
			ease: 'none',
			scrollTrigger: {
				trigger: section,
				start: 'top top',
				end: 'bottom top',
				scrub: 0.6,
                markers: false
			}
		});
	});
}

